import { __makeTemplateObject, __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import styled, { keyframes } from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import { variant } from '../../node_modules/@styled-system/variant/dist/index.esm.js';
var waveKeyframe = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    transform: translateX(-100%);\n  }\n  50% {\n    /* +0.5s of delay between each loop */\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"], ["\n  0% {\n    transform: translateX(-100%);\n  }\n  50% {\n    /* +0.5s of delay between each loop */\n    transform: translateX(100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"])));
var WaveBox = styled(Box)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &::after {\n    animation: ", " 1.6s linear 0.5s infinite;\n  }\n"], ["\n  &::after {\n    animation: ", " 1.6s linear 0.5s infinite;\n  }\n"])), waveKeyframe);
var SkeletonBox = styled(WaveBox)(variant({
  variants: {
    circle: {
      borderRadius: "50%"
    },
    rect: {}
  }
}), {
  position: "relative",
  overflow: "hidden",
  "::after": {
    background: "linear-gradient( 90deg, transparent,rgba(0, 0, 0, 0.04), transparent)",
    content: "''",
    position: "absolute",
    transform: "translateX(-100%)",
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
  }
});
SkeletonBox.defaultProps = {
  backgroundColor: "grey.4"
};
var Skeleton = function Skeleton(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? "rect" : _b,
    rest = __rest(_a, ["variant"]);
  return React__default.createElement(SkeletonBox, __assign({
    variant: variant
  }, rest));
};
var templateObject_1, templateObject_2;
export { Skeleton };